// @flow

import * as googleLibphonenumber from "google-libphonenumber";
import { isPhone as isValuePhone } from "../validatorsAlt/isPhone";
import i18n from "../../../i18n";
import { isPresent } from "../validatorsAlt/isPresent";

const phoneUtil = googleLibphonenumber.PhoneNumberUtil.getInstance();

export function isPhone(value: string) {
  return isValuePhone(value) ? undefined : i18n.t("validation:isPhone");
}

export function isPhoneOrNotPresent(value?: ?string) {
  if (!isPresent(value)) {
    return undefined;
  }
  return isValuePhone(value) ? undefined : i18n.t("validation:isPhone");
}

export function isPhoneNumberValid(value: string) {
  if (value && typeof value === "string") {
    try {
      return value.length > 4 && phoneUtil.isValidNumberForRegion(phoneUtil.parse(value, "DE"), "DE")
        ? undefined
        : i18n.t("validation:isPhoneValid");
    } catch (error) {
      return i18n.t("validation:isPhoneValid");
    }
  }
  return undefined;
}

export function isPhoneNumberValidForCsEdit(value: string) {
  if (value && typeof value === "string") {
    try {
      return value.length > 4 &&
        /^\d+$/.test(value) &&
        value.charAt(0) !== "0" &&
        phoneUtil.isValidNumberForRegion(phoneUtil.parse(value, "DE"), "DE")
        ? undefined
        : i18n.t("validation:isPhoneValid");
    } catch (error) {
      return i18n.t("validation:isPhoneValid");
    }
  }
  return undefined;
}
